<template>
  <validation-observer ref="validationObserver" v-slot="{ handleSubmit }">
    <b-modal
      v-model="modalAberto"
      :title="title"
      header-bg-variant="secondary"
      header-text-variant="light"
      @hide="closeModal"
      centered
    >
      <b-form @submit.prevent="handleSubmit(salvar)">
        <b-container>
          <b-row>
            <b-col cols="12">
              <default-form-validation-provider
                label="Tipo do(a) autor(a)"
                v-slot="defaultState"
              >
                <b-form-select
                  id="select-tipo"
                  :state="defaultState.state"
                  :options="listaTipos"
                  v-model="autor.IdTipoAutor"
                  class="mb-2"
                />
              </default-form-validation-provider>
            </b-col>
            <b-col cols="12">
              <default-form-validation-provider
                label="Nome do(a) autor(a)"
                v-slot="defaultState"
              >
                <b-form-input
                  id="input-nome"
                  :state="defaultState.state"
                  v-model="autor.NmAutor"
                  class="mb-2"
                  placeholder="Digite o nome"
                />
              </default-form-validation-provider>
            </b-col>
            <b-col cols="12">
              <default-form-validation-provider
                label="Início do mandato do(a) autor(a)"
                v-slot="defaultState"
              >
                <b-form-input
                  id="input-ini-mand"
                  :state="defaultState.state"
                  v-model="autor.NrAnoInicioMandato"
                  class="mb-2"
                  placeholder="Digite o ano do início do mandato"
                  type="number"
                  min="1950"
                  max="2100"
                />
              </default-form-validation-provider>
            </b-col>
            <b-col cols="12">
              <default-form-validation-provider
                label="Fim do mandato do(a) autor(a)"
                v-slot="defaultState"
              >
                <b-form-input
                  id="input-fim-mand"
                  :state="defaultState.state"
                  v-model="autor.NrAnoFimMandato"
                  class="mb-2"
                  placeholder="Digite o ano do fim do mandato"
                  type="number"
                  min="1950"
                  max="2100"
                />
              </default-form-validation-provider>
            </b-col>
          </b-row>
        </b-container>
      </b-form>
      <template #modal-footer>
        <b-button size="sm" variant="outline-secondary" @click="closeModal"
          >Cancelar</b-button
        >
        <b-button
          size="sm"
          variant="secondary"
          type="submit"
          @click="handleSubmit(salvar)"
        >
          Salvar
        </b-button>
      </template>
    </b-modal>
  </validation-observer>
</template>

<script lang="ts">
import { UtilsTS } from "@/utilsts";
import { mixins } from "vue-class-component";
import { ValidationObserver } from "vee-validate";
import { Component, Vue, Prop } from "vue-property-decorator";
import DefaultFormValidationProvider from "@/components/shared/DefaultFormValidationProvider.vue";
import { Autor } from "@/types/administracao/autor/autor";
import autorService from "@/services/administracao/autorService";
import { SelectValue } from "@/types/select-value";

@Component({
  components: {
    ValidationObserver,
    DefaultFormValidationProvider,
  },
})
export default class ModalSalvarAutor extends mixins(UtilsTS, Vue) {
  @Prop({ required: true }) autor!: Autor;
  @Prop({ required: true }) title!: string;
  @Prop({ required: true }) listaTipos!: SelectValue[];

  modalAberto = true;

  async created() {
    if (this.autor.IdAutor) {
      this.autor.IdTipoAutor =
        Number(
          this.listaTipos.find((tipo) => tipo.text === this.autor.TipoAutor)
            ?.value
        ) ?? null;
    } else {
      this.autor.IdTipoAutor = null;
    }
  }

  async salvar() {
    try {
      const response = await autorService.salvarAutor(this.autor);
      this.$toast.success("Autor(a) salvo(a) com sucesso!");
      this.closeModal();
    } catch (error: unknown) {
      this.tratarError(error);
      console.error("Erro ao salvar autor(a)", error);
    } finally {
      this.$emit("reload");
    }
  }

  closeModal() {
    this.$emit("close");
  }
}
</script>